module.exports = __webpack_public_path__ + "img/03d@2x.ad789581.svg";